import { useQuery } from 'data-fetching-client';
import { GET_LEGACY_INTEGRATION_EVENT_PROPERTIES } from 'flow-doctor-lib/queries/IntegratorQueries';
const useLegacyIntegrationEventProperties = ({
  portalId,
  eventId
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_LEGACY_INTEGRATION_EVENT_PROPERTIES, {
    variables: {
      portalId,
      eventId
    }
  });
  const dataToReturn = (() => {
    if (data) {
      var _properties$reduce;
      const properties = data.legacyIntegrationEventProperties.eventTypeIdProperties[eventId];
      return (_properties$reduce = properties === null || properties === void 0 ? void 0 : properties.reduce((acc, property) => Object.assign({}, acc, {
        [property.name]: property
      }), {})) !== null && _properties$reduce !== void 0 ? _properties$reduce : {};
    }
    return null;
  })();
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useLegacyIntegrationEventProperties;